import React, { useContext, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import PropTypes from "prop-types";
import CartContext from "../../../cartcontext/CartContext";

function ModalTemplate(props) {
  const { dispatchCart } = useContext(CartContext);

  const { modal, setModal } = props;
  const [qty, setQty] = useState(1);

  const handleClose = () => {
    setModal(false);
  };

  const handleCloseSubmit = () => {
    setModal(false);
    // if (qty) setCart([...cart, { guid: guid(), qty: qty, order: modal.menu }]);
    if (qty)
      dispatchCart({
        type: "ADD",
        payload: { guid: guid(), qty: qty, order: modal.menu },
      });
  };

  const guid = () => {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (
      c
    ) {
      var r = (Math.random() * 16) | 0,
        v = c == "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  };

  return (
    <div>
      <Modal show={modal.toggle} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>{modal.menu.food}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex justify-content-between">
            <div class="form-group">
              <label>Quantity</label>
              <input
                type="number"
                class="form-control"
                step="1"
                value={qty}
                pattern="[1-9]"
                min="1"
                max="20"
                onKeyPress={(e) => {
                  if (e.key === ".") {
                    e.preventDefault();
                  }
                }}
                onChange={(e) => {
                  const qty = e.target.value;
                  setQty(qty);
                  if (parseInt(qty) > 20) {
                    setQty(20);
                    e.preventDefault();
                  }
                }}
              />
            </div>
            <div class="form-group">
              <img
                style={{ width: "150px", height: "100px", objectFit: "cover" }}
                src={modal.menu.img}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleCloseSubmit}>
            Add to Cart - Rs {qty * modal.menu.price}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
ModalTemplate.propTypes = {
  modal: PropTypes.object,
  setModal: PropTypes.func,
};
export default ModalTemplate;
